<template>
  <div class="page-container">
    <md-app class="md-scrollbar">
      <md-app-toolbar class="md-primary">
        <span class="md-title">
					HNK ticketing -
					<span v-if="$store.state.currentTab.title"> {{ $store.state.currentTab.title }}</span>
					<span v-else-if="$store.state.selectedObject.title_hr">
						{{ $store.state.selectedObject.title_hr }} {{ $store.state.selectedObject.subscription_number }}
					</span>
					<span v-else-if="$store.state.selectedObject.play_title">
						{{ $store.state.selectedObject.play_title }} - {{ $store.state.selectedObject.performance_date }} - {{ $store.state.selectedObject.performance_time }}
					</span>
					<span v-else>Pretplate</span>
				</span>
				<div class="md-toolbar-section-end">
					<md-menu md-size="medium" :md-offset-x="-120">
						<md-button md-menu-trigger class="md-icon-button">
							<md-icon>person</md-icon>
						</md-button>

						<md-menu-content>
							<md-menu-item :href="$store.state.urls.logout">
								<span class="md-list-item-text">Odjava</span>
								<md-icon>exit_to_app</md-icon>
							</md-menu-item>
						</md-menu-content>
					</md-menu>
				</div>
      </md-app-toolbar>
      <md-app-drawer class="left-navigation md-scrollbar" md-permanent="full">
        <md-toolbar class="md-transparent" md-elevation="0">
          Izbornik
        </md-toolbar>
        <md-list>
					<md-list-item :class="isActive('employees')" v-on:click="$store.dispatch('setActiveTab', 'employees')"  v-if="$store.state.schema.employee">
						<md-icon>supervisor_account</md-icon>
						<span class="md-list-item-text">Zaposlenici</span>
					</md-list-item>
					<md-list-item :class="isActive('workPlaces')" v-on:click="$store.dispatch('setActiveTab', 'workPlaces')">
						<md-icon>work</md-icon>
						<span class="md-list-item-text">Radna mjesta</span>
					</md-list-item>

					<md-list-item md-expand :md-expanded.sync="expandCoupons" class="dropdown">
						<span class="md-list-item-text">Kuponi</span>
						<md-list slot="md-expand">
							<md-list-item :class="isActive('coupons')" v-on:click="$store.dispatch('setActiveTab', 'coupons')">
								<md-icon>note</md-icon>
								<span class="md-list-item-text">Kuponi</span>
							</md-list-item>
							<md-list-item :class="isActive('promoCodes')" v-on:click="$store.dispatch('setActiveTab', 'promoCodes')">
								<md-icon>local_offer</md-icon>
								<span class="md-list-item-text">Promo kodovi</span>
							</md-list-item>
							<md-list-item :class="isActive('transactionsCoupon')" v-on:click="$store.dispatch('setActiveTab', 'transactionsCoupon')" >
								<md-icon>credit_card</md-icon>
								<span class="md-list-item-text">Transakcije</span>
							</md-list-item>
						</md-list>
					</md-list-item>

					<md-list-item md-expand :md-expanded.sync="expandSubscription" class="dropdown">
						<span class="md-list-item-text">Pretplate</span>
						<md-list slot="md-expand">
							<md-list-item :class="isActive('subscriptions')" v-on:click="$store.dispatch('setActiveTab', 'subscriptions')">
								<md-icon>card_membership</md-icon>
								<span class="md-list-item-text">Pretplate</span>
							</md-list-item>
							<md-list-item :class="isActive('subscribers')" v-on:click="$store.dispatch('setActiveTab', 'subscribers')">
								<md-icon>people</md-icon>
								<span class="md-list-item-text">Pretplatnici</span>
							</md-list-item>
							<md-list-item :class="isActive('reservations')" v-on:click="$store.dispatch('setActiveTab', 'reservations')">
								<md-icon>calendar_today</md-icon>
								<span class="md-list-item-text">Rezervacije</span>
							</md-list-item>
							<md-list-item :class="isActive('subscriptionSales')" v-on:click="$store.dispatch('setActiveTab', 'subscriptionSales')" >
								<md-icon>credit_card</md-icon>
								<span class="md-list-item-text">Transakcije</span>
							</md-list-item>
							<md-list-item md-expand :md-expanded.sync="expandSubscriptionReports" class="dropdown">
								<md-icon>poll</md-icon>
								<span class="md-list-item-text">Izvješća</span>
								<md-list slot="md-expand">
									<md-list-item :class="isActive('reportsGeneral')" class="md-inset" v-on:click="$store.dispatch('setActiveTab', 'reportsGeneral')">
										<span class="md-list-item-text">Po pretplatama</span>
									</md-list-item>
									<md-list-item :class="isActive('reportsPayment')" class="md-inset" v-on:click="$store.dispatch('setActiveTab', 'reportsPayment')">
										<span class="md-list-item-text">Po načinu plaćanja</span>
									</md-list-item>
								</md-list>
							</md-list-item>
						</md-list>
					</md-list-item>

					<md-list-item md-expand :md-expanded.sync="expandTicket" class="dropdown">
						<span class="md-list-item-text">Ulaznice</span>
						<md-list slot="md-expand">
							<md-list-item :class="isActive('sold')" v-on:click="$store.dispatch('setActiveTab', 'sold')">
								<md-icon>local_offer</md-icon>
								<span class="md-list-item-text">Prodano</span>
							</md-list-item>
							<md-list-item :class="isActive('offers')" v-on:click="$store.dispatch('setActiveTab', 'offers')">
								<md-icon>local_offer</md-icon>
								<span class="md-list-item-text">Ponude</span>
							</md-list-item>
							<md-list-item :class="isActive('pricelistsList')" v-on:click="$store.dispatch('setActiveTab', 'pricelistsList')">
								<md-icon>view_list</md-icon>
								<span class="md-list-item-text">Cjenici</span>
							</md-list-item>
							<md-list-item :class="isActive('discounts')" v-on:click="$store.dispatch('setActiveTab', 'discounts')">
								<md-icon>card_giftcard</md-icon>
								<span class="md-list-item-text">Popusti</span>
							</md-list-item>
							<md-list-item :class="isActive('stages')" v-on:click="$store.dispatch('setActiveTab', 'stages')">
								<md-icon>business</md-icon>
								<span class="md-list-item-text">Pozornice</span>
							</md-list-item>
							<md-list-item :class="isActive('plays')" v-on:click="$store.dispatch('setActiveTab', 'plays')">
								<md-icon>movie</md-icon>
								<span class="md-list-item-text">Predstave</span>
							</md-list-item>
							<md-list-item :class="isActive('performances')" v-on:click="$store.dispatch('setActiveTab', 'performances')">
								<md-icon>event</md-icon>
								<span class="md-list-item-text">Raspored</span>
							</md-list-item>
							<md-list-item :class="isActive('sponsors')" v-on:click="$store.dispatch('setActiveTab', 'sponsors')">
								<md-icon>monetization_on</md-icon>
								<span class="md-list-item-text">Sponzori</span>
							</md-list-item>
							<md-list-item :class="isActive('partners')" v-on:click="$store.dispatch('setActiveTab', 'partners')">
								<md-icon>business_center</md-icon>
								<span class="md-list-item-text">Poslovni partneri</span>
							</md-list-item>
							<md-list-item :class="isActive('leases')" v-on:click="$store.dispatch('setActiveTab', 'leases')">
								<md-icon>assignment</md-icon>
								<span class="md-list-item-text">Zakupi</span>
							</md-list-item>
							<md-list-item :class="isActive('seasonsList')" v-on:click="$store.dispatch('setActiveTab', 'seasonsList')">
								<md-icon>book</md-icon>
								<span class="md-list-item-text">Sezone</span>
							</md-list-item>
							<md-list-item :class="isActive('ticketSales')" v-on:click="$store.dispatch('setActiveTab', 'ticketSales')" >
								<md-icon>credit_card</md-icon>
								<span class="md-list-item-text">Transakcije</span>
							</md-list-item>
							<md-list-item md-expand :md-expanded.sync="expandTicketReports" class="dropdown">
								<md-icon>poll</md-icon>
								<span class="md-list-item-text">Izvješća</span>
								<md-list slot="md-expand">
									<md-list-item :class="isActive('reportsCash')" class="md-inset" v-on:click="$store.dispatch('setActiveTab', 'reportsCash')">
										<span class="md-list-item-text">Gotovinsko</span>
									</md-list-item>
									<md-list-item :class="isActive('reportsIncome')" class="md-inset" v-on:click="$store.dispatch('setActiveTab', 'reportsIncome')">
										<span class="md-list-item-text">Promet u periodu</span>
									</md-list-item>
									<md-list-item :class="isActive('reportsPlay')" class="md-inset" v-on:click="$store.dispatch('setActiveTab', 'reportsPlay')">
										<span class="md-list-item-text">Po predstavi</span>
									</md-list-item>
									<md-list-item :class="isActive('reportsPlayOnline')" class="md-inset" v-on:click="$store.dispatch('setActiveTab', 'reportsPlayOnline')">
										<span class="md-list-item-text">Po predstavi (Online)</span>
									</md-list-item>
									<md-list-item :class="isActive('reportsPerformanceGeneral')" class="md-inset" v-on:click="$store.dispatch('setActiveTab', 'reportsPerformanceGeneral')">
										<span class="md-list-item-text">Kumulativni</span>
									</md-list-item>
									<md-list-item :class="isActive('reportsCashRegister')" class="md-inset" v-on:click="$store.dispatch('setActiveTab', 'reportsCashRegister')">
										<span class="md-list-item-text">Blagajnički</span>
									</md-list-item>
									<md-list-item :class="isActive('reportsCashRegisterPlay')" class="md-inset" v-on:click="$store.dispatch('setActiveTab', 'reportsCashRegisterPlay')">
										<span class="md-list-item-text">Blagajnički - Predstava</span>
									</md-list-item>
									<md-list-item :class="isActive('reportsGratisByDate')" class="md-inset" v-on:click="$store.dispatch('setActiveTab', 'reportsGratisByDate')">
										<span class="md-list-item-text">Gratis po danima</span>
									</md-list-item>
									<md-list-item :class="isActive('reportsAboutPlay')" class="md-inset" v-on:click="$store.dispatch('setActiveTab', 'reportsAboutPlay')">
										<span class="md-list-item-text">O izvedbi</span>
									</md-list-item>
									<md-list-item :class="isActive('reportsAboutScan')" class="md-inset" v-on:click="$store.dispatch('setActiveTab', 'reportsAboutScan')">
										<span class="md-list-item-text">Skenirano</span>
									</md-list-item>
									<md-list-item :class="isActive('reportsGeneralAll')" class="md-inset" v-on:click="$store.dispatch('setActiveTab', 'reportsGeneralAll')">
										<span class="md-list-item-text">Sve predstave</span>
									</md-list-item>
									<md-list-item :class="isActive('kontoHR')" class="md-inset" v-on:click="$store.dispatch('setActiveTab', 'kontoHR')">
										<span class="md-list-item-text">Konto HR</span>
									</md-list-item>
									<md-list-item :class="isActive('reportsInGuests')" class="md-inset" v-on:click="$store.dispatch('setActiveTab', 'reportsInGuests')">
										<span class="md-list-item-text">U gostima</span>
									</md-list-item>
								</md-list>
							</md-list-item>
						</md-list>
					</md-list-item>
				</md-list>
      </md-app-drawer>
    	<md-app-content>
				<div>
					<md-progress-spinner :md-diameter="65" :md-stroke="5" v-if="!$store.state.pageLoaded || $store.state.loading" md-mode="indeterminate"></md-progress-spinner>
					<router-view></router-view>
					<md-snackbar md-position="center" :md-duration="Infinity" :md-active.sync="$store.state.showNotification" md-persistent>
						<span>Objavljena je nova verzija administracijskog sučelja, za ispravan nastavak rada molimo Vas osvježite program što prije.</span>
						<md-button class="md-primary" v-on:click="reload">Osvježi</md-button>
					</md-snackbar>
				</div>
    </md-app-content>
  </md-app>
  </div>
</template>

<script>
export default {
	name: 'Admin',

  data(){
    return {
      menuVisible: false,
			expandTicket: false,
			expandCoupons: false,
			expandSubscription: false,
			expandTicketReports: false,
			expandSubscriptionReports: false,
    }
	},

	methods:{
		isActive(tab){
			if(this.$store.state.currentTab.tab == tab) return 'is-active';
		},

		reload(){
			window.location.reload();
		}
	}
}
</script>

<style lang="scss">
@import "~vue-material/dist/theme/engine";

@include md-register-theme("default", (
  primary: #448aff,
  accent: #ff5252,
  background-variant: #448aff,
));

@import "~vue-material/dist/theme/all";

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to{
  transition: 0s;
  opacity: 0;
  transform: translateZ(0);
}

html.md-theme-default {
	background-color: #fff !important;
}

main.md-app-container{
	transform: none;
}

.md-icon.md-theme-default.md-icon-font.color-red{
	color: #ff5252;
}

.md-icon.md-theme-default.md-icon-font.color-green{
	color: #34a853;
}

.md-field{
  &.checkbox-validation{
    padding-top: 0;
    min-height: auto;
    &:before, &:after{
      display: none;
    }
  }
}

.v-align-middle{
	vertical-align: middle;
}

.md-button{
	transition: 0s;
}

.full-width{
	display: block;
	width: 100%;
}

.small-table{
  max-width: 1024px;
}

.capitalize{
	text-transform: capitalize;
}

.admin{
	overflow-x: hidden;
	overflow-y: scroll;
	.md-app{
		min-height: 100vh;
	}

	.md-app-container{
		padding-left: 250px !important;
	}

	.md-snackbar{
		max-width: 900px;
	}

	.filter-wrapper{
		display: flex;
		margin-bottom: 50px;
		.inputs-wrapper{
			min-width: 300px;
			& + .inputs-wrapper{
				margin-left: 50px;
			}

			.date-wrapper{
				display: flex;
				.md-field{
					& + .md-field{
						margin-left: 35px;
					}
				}
			}
		}
		.md-field{
			max-width: 300px;
		}
		.with-button{
			align-self: flex-end;
			margin-bottom: 20px;
		}

		.md-radio{

		}
	}

	.md-dialog{
		border-radius: 0;
	}

	.fixed-print-btn{
		position: fixed;
    bottom: 15px;
		right: 15px;
		z-index: 10000;
	}

	.lighter{
		font-weight: lighter;
	}

	.dropdown .md-list{
		padding: 0;
	}

	.md-list-item-expand{
		transition: background-color 200ms;
		.md-list-expand{
			opacity: 1;
		}
	}

	.left-navigation{
		position: absolute;
		top: 0;
		left: 0;
		bottom: 0;
		max-height: 100%;
		overflow-y: scroll;
		.md-list-item.is-active{
			.md-list-item-button{
				background-color: rgba(0,0,0,.07);
			}
		}
	}

	.table-align-top td{
		vertical-align: top;
	}


	.md-list.md-theme-default .md-list-item-expand.md-active{
		border-color: transparent !important;
		background-color: rgba(0,0,0,.12) !important;
	}

	.md-scrollbar.md-theme-default::-webkit-scrollbar-corner, .md-scrollbar.md-theme-default::-webkit-scrollbar-track{
		background-color: #ddd;
	}

	.md-scrollbar.md-theme-default::-webkit-scrollbar-thumb{
		background-color: #aaa;
	}

	.md-menu-content{
		z-index: 9999;
		max-width: 400px !important;
	}

	.md-list-expand{
		transform: translate3d(0,0,0);
	}

	.selected-seats{
		.md-list-item{
			display: block;
		}

		.md-card{
			margin: 0;
		}
	}

	.md-tabs-navigation{
		overflow: hidden;
		display: inline-block;
		margin: 0 auto;
	}

	.theatre{
		margin-bottom: 0;
	}

	.card-print{
		display: none;
	}

	.md-datepicker-overlay{
		opacity: 0.5;
		transition: opacity 300ms !important;
		&.md-overlay-enter-to{
			opacity: 0.5;
		}

		&.md-overlay-leave-to{
			opacity: 0;
		}
  }

	.md-datepicker-dialog.md-theme-default{
		position: fixed !important;
		top: 50% !important;
		left: 50% !important;
		transform: translate(-50%, -50%);
		z-index: 10000;
	}

	.md-datepicker-body-content{
		height: auto !important;
		min-height: 300px;
	}

	.t-align-center{
		text-align: center;
	}

	.t-align-left{
		text-align: left;
	}

	.t-align-right{
		text-align: right;
	}

	.back-button{
		position: absolute;
	}

	.search-field{
		max-width: 300px;
	}

	.left-navigation{
		width: 250px;
	}

  .md-field{
    .md-icon:after{
      display: none;
    }
  }

	.md-list-item-expand{
		border-bottom: 0;
		.md-list-item-expand:not(.md-active) .md-list-expand-icon{
			transform: none;
		}
	}

	.md-list-item-expand.md-active .md-list-expand-icon{
		transform: rotate(180deg)
	}


  .md-toolbar .md-tabs{
    padding-left: 0;
  }

  .md-table-row.md-selected-single{
    font-weight: normal;
  }

	.md-table-head-label{
		color: #000;
	}

	.md-progress-spinner{
		position: fixed;
		top: 50%;
		left: 50%;
		transform: translate3d(-50%, -50%, 0);
		z-index: 1000000;
	}

	.theatre-seats-holder{
		text-align: center;
		overflow: hidden;
		div{
			position: relative;
			&:after{
				content: "";
				display: block;
				padding-top: 90%;
			}
		}
	}

	.theatre-seats{
		position: relative;
		display: flex;
		flex-direction: column;
		width: calc(calc(100% / 1.5) - 30px);
		margin-right: 30px;
		padding: 0 0 45px;

		svg{
			position: absolute;
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
			width: 100%;
			height: 100%;
			&.none{
				.seat circle{
					pointer-events: none;
				}
			}
		}
	}

	.theatre-container{
		margin: 20px 20px 0;
		&.theatre-tickets{
    	margin: 30px auto 0;
			.theatre-seats{
				width: 100%;
			}
		}
		.theatre-seats{
			width: calc(100% - 350px);
			svg .seat circle{
				stroke-width: 1px;
			}
		}

		.theatre-seats-holder{
			min-height: calc(100vh - 230px);
			svg{
				max-height: 100%;
				width: auto;
				height: auto;
			}
		}
	}

	.edit-form{
		max-width: 550px;
		overflow-y: scroll;
		.md-card-content{
			padding-bottom: 0;
		}
	}

	.md-table-content table{
		.md-numeric{
			width: 70px;
			max-width: 70px;
		}

		.md-table-cell{
			padding-top: 8px;
			padding-bottom: 8px;
			&.small-cell{
				width: 150px;
				max-width: 150px;
				text-align: center;
			}

			&.tiny-cell{
				width: 100px;
				max-width: 100px;
				text-align: center;
			}

			&.actions-cell{
				width: 201px;
				max-width: 201px;
				text-align: center;
			}

			&.tc{
				text-align: center;
			}
		}
	}

	.dialog-container{
		width: 100%;
		overflow-y: scroll;
		transform: translate3d(-50%, calc(-50% - 0.5px), 0);
		min-height: 80%;
		.md-layout, .md-card-content{
			max-width: 500px;
			margin-left: auto;
			margin-right: auto;
			& + .md-layout{
				margin-top: 50px;
			}
		}

		.user-wrapper{
			position: relative;
			margin-top: 75px;
			.back-button{
				position: absolute;
				top: 0;
				right: 0;
				left: auto;
				transform: translateX(50%);
			}
		}

		.back-button{
			top: 20px;
			left: 20px;
		}

		.md-card{
			box-shadow: unset;
		}

		.md-title{
			text-align: center;
		}

		.md-layout{
			h4{
				width: 100%;
				text-align: left;
				font-weight: normal;
				margin: 0 0 30px;
			}

			&.centered{
				justify-content: center;
			}
		}
	}



	.details-page, .details-page-inner{
		position: fixed;
    top: 0;
    z-index: 10001;
    background: #fff;
    left: 250px;
    right: 0;
    bottom: 0;
    margin-top: 75px;
		max-height: 100vh;
		overflow-y: scroll;
	}

	.details-page-inner{
	}
}

.download-button{
	position: absolute;
	top: 80px;
	right: 20px;
}

.md-dialog{
	z-index: 999999;
}

.md-overlay.md-fixed, body>.md-overlay{
  z-index: 99999;
}

.md-menu-content.md-select-menu, .md-datepicker-dialog.md-theme-default{
  z-index: 999923190 !important;
}

.overflow{
	overflow: hidden !important;
}

body{
	overflow-x: hidden !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Admin.vue